angular
  .module 'bookAndPay'
  .directive 'ezidebitForm', () ->
    restrict: 'EA'
    template: require('templates/book_and_pay/ezidebit_form.html.slim')
    scope:
      cart: '='
      months: '='
      years: '='
      currency: '='
      fees: '='
      expired: '='
      toNewCart: '&'
      verifyCaptcha: '&'
      setLoading: '&'
    controller: (
      $scope,
      $state,
      $http,
      $q,
      $timeout,
      CreditCardValidationService,
      DataService
    ) ->
      $scope.id = Math.floor(Math.random() * 1000000)
      $scope.authToken = $('meta[name=csrf-token]').attr('content')
      $scope.gymName = DataService.gym_name
      $scope.creditCard = {}
      cartType = if $scope.cart.cart_type is 'payment_only_cart'
        'po'
      else
        undefined

      toggleLoading = (val) ->
        $scope.isLoading = val
        $scope.setLoading(loading: val)

      initEzidebit = ->
        $timeout ->
          window.initEziDebit()
          eziDebit.init($scope.publicKey, {
            submitAction: "ChargeCard",
            submitButton: "submit-ezidebit-payment-#{$scope.id}",
            submitCallback: onSubmit,
            submitError: onSubmitError,
            nameOnCard: "nameOnCard",
            cardNumber: "cardNumber",
            cardExpiryMonth: "expiryMonth",
            cardExpiryYear: "expiryYear",
            cardCCV: "ccv",
            paymentAmount: "paymentAmount",
            paymentReference: "paymentReference"
          }, $scope.cart.realtime_js_url)

      $scope.$watch 'publicKey', (key) ->
        if key && !$scope.cart.payment_processing_locked
          initEzidebit()

      $scope.checkCardNumber = ->
        $scope.creditCard.cardNumber = $scope.creditCard.cardNumber?.replace(/[^0-9]/g, '')
        $scope.cardNumberValid = CreditCardValidationService.check($scope.creditCard.cardNumber)
        $scope.errorMessage = if !$scope.cardNumberValid && $scope.creditCard.showCardValidation
          'Card number is invalid'
        else
          ''

      $scope.onCardInputBlur = ->
        $scope.creditCard.showCardValidation = true
        $scope.checkCardNumber()

      onAuthenticationError = ->
        if window.Rollbar
          window.Rollbar.error('Book and pay card authentication error', $scope.errorMessage)

      onSubmit = (response) ->
        $timeout ->
          if response.PaymentResult is 'F'
            $scope.errorMessage = 'Failed. Payment was rejected by the bank.'
            toggleLoading(false)
            onAuthenticationError()
            return
          if response.PaymentResult is 'U'
            $scope.errorMessage =
              'Payment cannot be submitted to the bank at this time. Please try again later.'
            toggleLoading(false)
            onAuthenticationError()
            return
          if response.PaymentResult is 'A'
            submitPaymentResult(response.BankReceiptID)
          else
            if window.Rollbar
              window.Rollbar.error('Book and pay card authentication error', message: 'Unknown error', data: response)

      submitPaymentResult = (receiptId) ->
        uuid = $scope.cart.cart_uuid
        url = "/websites/#{window.DATA.domain}/book_and_pay/carts/#{uuid}/handle_payment_result"
        params =
          payment_result: 'A'
          bank_receipt_id: receiptId
        $http.put(url, params).then (response) ->
          toggleLoading(false)
          $state.go 'bookAndPay.complete', uuid: $scope.cart.cart_uuid
        , (response) ->
          if window.Rollbar
            window.Rollbar.error('Book and pay handle_payment_result error', response.data)
          toggleLoading(false)
          $scope.errorMessage = 'An unexpected error occurred. Please try again later.'

      onSubmitError = (error) ->
        $timeout ->
          $scope.errorMessage = error
          onAuthenticationError()
          toggleLoading(false)

      $scope.onRecaptchaSubmitted = (token) ->
        uuid = $scope.cart.cart_uuid
        url = "/websites/#{window.DATA.domain}/book_and_pay/carts/#{uuid}/verify_ezidebit"
        $http.put(url, recaptcha_token: token).then (response) ->
          $scope.publicKey = response.data.public_key
          $timeout ->
            onPaymentDetailsSubmitReady()
          , 100
        , (response) ->
          $scope.errorMessage = response.data?.recaptcha_failure_message || response.data?.error || "Request could not be completed. Please try again"
          toggleLoading(false)

      $scope.onRecaptchaError = () ->
        $scope.errorMessage = "Unable to perform CAPTCHA check. If enabled, consider disabling VPN / IP tracking software and try again."
        toggleLoading(false)

      $scope.isReady = ->
        $scope.cardNumberValid &&
          $scope.creditCard.cardholderName &&
          $scope.creditCard.expirationMonth &&
          $scope.creditCard.expirationYear &&
          $scope.creditCard.ccv &&
          !$scope.isLoading

      lock = ->
        if $scope.cart.payment_processing_locked || $scope.paymentProcessingLocked
          deferred = $q.defer()
          deferred.resolve()
          deferred.promise
        else
          uuid = $scope.cart.cart_uuid
          url = "/websites/#{window.DATA.domain}/book_and_pay/carts/#{uuid}/lock_payment_form"
          $http.put(url)

      $scope.onCardSubmitted = ->
        return unless $scope.isReady()
        toggleLoading(true)
        $scope.errorMessage = ''
        $scope.$emit 'recaptcha:execute'

      onPaymentDetailsSubmitReady = ->
        lock().then () ->
          $scope.paymentProcessingLocked = true
          angular.element("#submit-ezidebit-payment-#{$scope.id}").click()
        , () ->
          $scope.cart.payment_processing_locked = true
          toggleLoading(false)

      $scope.cancel = ->
        $state.go 'bookAndPay.newCart', uuid: $scope.cart.membership_plan_uuid, ct: cartType
